import React from "react";
import variables from "@/common/globalVariables";
import Bubble from "@/common/UI/Bubble";
import Icon from "@/common/UI/Icon";
import Title from "@/common/UI/Title";
import FavoriteButton from "../JobFavoriteButton/FavoriteButton";
import PrompToRegister from "@/components/users/PrompToRegister";
import Translator from "@/components/hoc/Translator";
import JobCompensationBubbles from "../JobCompensationBubbles";
import JobPerksBubbles from "../JobPerksBubbles";
import SendToFriendButton from "../sendJob/SendToFriendButton";

const jobListingTitleStyles = `color: ${variables.lightColor};`;
const JobListingLocationStyles = `color: ${variables.lightColor}; opacity: 0.7;`;

const JobListingHeader = (props) => (
  <div className="JobListingHeader" data-test="job-listing-header">
    <Title size={"l"} styles={jobListingTitleStyles} data-test="title-section">
      <Translator>{props.title}</Translator>
    </Title>
    <Title
      size={"m"}
      styles={JobListingLocationStyles}
      weight="400"
      data-test="location-section"
    >
      <Icon icon="map marker alternate" />{" "}
      <Translator>{props.location}</Translator>
    </Title>
    <div className="JobListingHeaderBar">
      <div className="JobListingMeta">
        {(props.showCompensation || !props.perks) && (
          <JobCompensationBubbles
            minCompensation={props.minCompensation}
            maxCompensation={props.maxCompensation}
          />
        )}
        {props.showType && (
          <Bubble color="2">
            <Translator>{props.type}</Translator>
          </Bubble>
        )}
        {props.showPerks && <JobPerksBubbles perks={props.perks} />}
      </div>
      {props.hideFavoriteButton ? null : (
        <PrompToRegister>
          <FavoriteButton jobId={props.jobId} count={props.favoritesCount} />
        </PrompToRegister>
      )}
    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "15px",
      }}
    >
      <SendToFriendButton jobId={props.jobId} />
    </div>
    <style jsx>{`
      .JobListingHeader {
        width: 100%;

        padding: 40px;
        background-color: ${variables.accentColor2};
        border-top-right-radius: 30px;
        border-top-left-radius: ${variables.roundedRadius};
        z-index: auto;
        position: relative;
      }

      .JobListingMeta {
        display: flex;
        flex-wrap: wrap;
      }

      .JobListingMeta :global(> *) {
        margin-bottom: 10px;
      }

      .JobListingHeaderBar {
        display: flex;
        justify-content: space-between;
        position: relative;
      }

      @media only screen and (max-width: 520px) {
        .JobListingHeader {
          width: 100%;
          padding: 40px 40px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
        }

        .JobListingHeader p {
          padding-bottom: 30px;
        }
      }
    `}</style>
  </div>
);

export default JobListingHeader;
